import React from 'react';

import { IconButton, LinkIconButton } from '@atlaskit/button/new';
import { fg } from '@atlaskit/platform-feature-flags';
import { PanelAction } from '@atlassian/panel-system';

import type { PreviewPanelActionProps } from './types';

export const PreviewPanelAction: React.ForwardRefExoticComponent<Omit<PreviewPanelActionProps, "ref"> & React.RefAttributes<any>> = React.forwardRef(function PreviewPanelAction(
	{ icon, label, onClick, href, testId, analyticsContext }: PreviewPanelActionProps,
	ref: React.Ref<any>,
) {
	if (fg('ads-panel-system-gpp')) {
		if (analyticsContext || href) {
			return href ? (
				<LinkIconButton
					icon={icon}
					label={label}
					onClick={onClick}
					href={href}
					testId={testId}
					analyticsContext={analyticsContext}
					appearance="subtle"
					target="_blank"
					ref={ref}
					role="button"
				/>
			) : (
				<IconButton
					icon={icon}
					label={label}
					onClick={onClick}
					testId={testId}
					analyticsContext={analyticsContext}
					appearance="subtle"
					ref={ref}
					role="button"
				/>
			);
		}

		return (
			<PanelAction
				ref={ref}
				icon={icon}
				label={label}
				onClick={onClick}
				testId={testId}
				appearance="subtle"
			/>
		);
	}

	return href ? (
		<LinkIconButton
			icon={icon}
			label={label}
			onClick={onClick}
			href={href}
			testId={testId}
			analyticsContext={analyticsContext}
			appearance="subtle"
			target="_blank"
			ref={ref}
			role="button"
		/>
	) : (
		<IconButton
			icon={icon}
			label={label}
			onClick={onClick}
			testId={testId}
			analyticsContext={analyticsContext}
			appearance="subtle"
			ref={ref}
			role="button"
		/>
	);
});
